module.exports = __webpack_public_path__ + "static/bett1ACES-375x537-v2-358df96c860e870d5dfa781779609347.mp4";